import { useId } from 'react';

export interface ToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  hint?: string;
  disabled?: boolean;
}

/**
 * Interruptor ligado/desligado.
 *
 * Mostra a PALAVRA ("Sim"/"Não") e um ícone, não só um carril verde ou cinzento:
 * um carril colorido sozinho é indistinguível para quem não vê bem a cor, e ela
 * usa isto muitas vezes sem óculos.
 */
export function Toggle({ label, checked, onChange, hint, disabled = false }: ToggleProps) {
  const base = useId();
  const hintId = `${base}-hint`;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-describedby={hint ? hintId : undefined}
      className="flos-toggle"
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="flos-toggle__label">
        {label}
        {hint ? (
          <span className="flos-toggle__hint" id={hintId}>
            {hint}
          </span>
        ) : null}
      </span>
      <span className="flos-toggle__state" aria-hidden="true">
        <span className="flos-icon">{checked ? '✓' : '✕'}</span>
        {checked ? 'Sim' : 'Não'}
      </span>
    </button>
  );
}
